module.exports = __webpack_public_path__ + "img/redRubin@2x.2abf323.webp";